export class User {
  public dossierNumber: string;
  public pinCode: string;

}



// WEBPACK FOOTER //
// ./src/app/auth/signin/user.ts